<div class="dialog-header">
  <h2 class="dialog-title">Critical Values — t-Distribution</h2>
  <button class="close-btn" (click)="close()">
    <dojo-icon icon="xmark" [size]="14" />
  </button>
</div>

<div class="dialog-body">
  <!-- Normal distribution diagram -->
  <dojo-normal-distribution-diagram [highlightAlpha]="diagramAlpha()" />

  <!-- Lookup guide -->
  <div class="lookup-guide">
    <span class="guide-label">Your lookup</span>
    <div class="lookup-flow">
      <span class="lookup-chip">df = {{ dfLabel() }}</span>
      <dojo-icon icon="arrow-right" faPrefix="fas" [size]="11" class="flow-arrow" />
      <span class="lookup-chip">α = {{ alphaLabel() }}</span>
      <dojo-icon icon="arrow-right" faPrefix="fas" [size]="11" class="flow-arrow" />
      <span class="lookup-chip chip-result">
        <dojo-markdown-viewer [content]="criticalValueLabel()" />
      </span>
    </div>
    <div class="lookup-conclusion">
      <dojo-markdown-viewer [content]="conclusionLine()" />
    </div>
  </div>

  <!-- Critical values table -->
  <dojo-critical-values-table
    [highlightDf]="result().degreesOfFreedom"
    [highlightAlpha]="result().alpha"
    (alphaHover)="onAlphaHover($event)"
  />
</div>
